module.exports = __webpack_public_path__ + "static/media/Båt.c5d4fda1.PNG";